import { ZPARDataFooter } from './ZPAR_DataFooter';
import { MXDataFooter } from './MX_DataFooter';
import { UBPEDataFooter } from './UBPE_DataFooter';

const siteId = process.env.REACT_APP_BUILD_SITE;

const setDataFooter = () => {
  const footerData = {};
  if (siteId === 'ZPAR') {
    footerData.footerLinks = ZPARDataFooter.footerLinks;
    footerData.socialMedia = ZPARDataFooter.socialMedia;
    footerData.appsLinks = ZPARDataFooter.appsLinks;
    footerData.legalLinks = ZPARDataFooter.legalLinks;
    footerData.fiscalQR = ZPARDataFooter.fiscalQR;
    footerData.siteName = ZPARDataFooter.siteName.name;
    footerData.srcLogo = ZPARDataFooter.logo.src;
    return footerData;
  }
  if (siteId === '24MX') {
    footerData.footerLinks = MXDataFooter.footerLinks;
    footerData.socialMedia = MXDataFooter.socialMedia;
    footerData.appsLinks = MXDataFooter.appsLinks;
    footerData.legalLinks = MXDataFooter.legalLinks;
    footerData.fiscalQR = MXDataFooter.fiscalQR;
    footerData.siteName = MXDataFooter.siteName.name;
    footerData.srcLogo = MXDataFooter.logo.src;
    return footerData;
  }
  if (siteId === 'UBPE') {
    footerData.footerLinks = UBPEDataFooter.footerLinks;
    footerData.socialMedia = UBPEDataFooter.socialMedia;
    footerData.appsLinks = UBPEDataFooter.appsLinks;
    footerData.legalLinks = UBPEDataFooter.legalLinks;
    footerData.fiscalQR = UBPEDataFooter.fiscalQR;
    footerData.siteName = UBPEDataFooter.siteName.name;
    footerData.srcLogo = UBPEDataFooter.logo.src;
    return footerData;
  }
  return footerData;
};

const { footerLinks, socialMedia, appsLinks, legalLinks, fiscalQR, siteName, srcLogo } = setDataFooter();
export { footerLinks, socialMedia, appsLinks, legalLinks, fiscalQR, siteName, srcLogo };
